/**
 * @class {RoadgamesEvent.Finished}
 * @extends {RoadgamesEvent.Base}
 * @param {DR.events.struct.Event} event
 * @param {DR.events.struct.Stats} stats
 */
RoadgamesEvent.Finished = Class(
	/**
	 * @lends {RoadgamesEvent.Finished#}
	 */
	{
		__NAME: 'RoadgamesEvent.Finished',

		state: 'finished',
		_currentStats: null,

		_draw() {
			this._drawWelcome();
			this._drawTopSponsors();
			this._drawAboutGame();
			this._drawStats();
			this._drawPrizeSponsors();
			this._drawVideo();
			this._drawLiveAwards();
			this._drawTop();
			this._drawApiGallery();
			this._drawInstagramFeed();
		},

		_drawWelcomeBottom() {
			return mkE({
				tag: 'div',
				className: 'single-event-welcome-purchase',
				els: [
					{
						tag: 'a',
						href: '#results',
						className: 'button button-turquoise',
						text: D.Lang.get('event.finished.results'),
						onclick: function () {
							document.getElementById('results').scrollIntoView({
								behavior: 'smooth'
							});
							return false;
						}
					}
				]
			});
		},

		_drawResultsWelcome() {
			let text = D.Lang.get('event.finished.welcome');
			let textKey = 'event.finished.welcome.' + this.event.id;
			if (D.Lang.get(textKey) !== textKey) {
				text = D.Lang.get(textKey);
			}
			text = text.replace('%TEAMS%', this.stats.teams + ' ' + D.Lang.nget(this.stats.teams, 'event.finished.teams'));
			text = text.replace('%TASKS%', this.stats.tasks + ' ' + D.Lang.nget(this.stats.tasks, 'event.finished.tasks'));
			text = text.replace('%EVENT%', this.event.title);
			let welcome = mkE({
				tag: 'div',
				className: 'container single-event-welcome',
				els: [
					{
						tag: 'div',
						className: 'single-event-block',
						els: [
							{
								tag: 'h1',
								className: 'title',
								text: this.event.title
							},
							{
								tag: 'p',
								className: 'text',
								text: text
							},
							{
								tag: 'div',
								className: 'single-event-welcome-purchase',
								els: [
									{
										tag: 'a',
										href: '#results',
										className: 'button button-turquoise',
										text: D.Lang.get('event.finished.results'),
										onclick: function (e) {
											document.getElementById('results').scrollIntoView({
												behavior: 'smooth'
											});
											return false;
										}
									}
								]
							}
						]
					}
				]
			});

			let image = this.event.landing.pic ? this.event.landing.pic.large : null;
			if( screen.width < 720 ) {
				if( this.event.landing.picMobile ) {
					image = this.event.landing.picMobile.original;
				} else if( this.event.hasImage ) {
					image = this.event.image.original;
				}
			}

			mkE({
				tag: 'div',
				id: 'single-event-background',
				els: [
					{
						tag: 'div',
						id: 'single-event-background-picture',
						style: image ? {
							backgroundImage: 'url(' + image + ')'
						} : {}
					},
					{
						tag: 'div',
						id: 'single-event-background-mask'
					},
					welcome
				]
			}).append(this.node);
		},

		_drawAboutGame() {
			let text = D.Lang.get('event.finished.about.text');
			let textKey = 'event.finished.about.text.' + this.event.id;
			if (D.Lang.get(textKey) !== textKey) {
				text = D.Lang.get(textKey);
			}
			let startDate = new D.Date(this.event.startTime);
			text = text.replace('%YEAR%', startDate.format('Y'));
			text = text.replace('%DATE%', startDate.format('j. %L'));
			text = text.replace('%TEAMS%', this.stats.teams + ' ' + D.Lang.nget(this.stats.teams, 'event.finished.teams'));
			text = text.replace('%PARTICIPANTS%', this.stats.participants + ' ' + D.Lang.nget(this.stats.participants, 'event.finished.participants'));
			let seconds = this.event.endTime - this.event.startTime;
			let hours = Math.ceil(seconds / 3600);
			text = text.replace('%LENGTH%', hours + ' ' + D.Lang.nget(hours, 'event.finished.hours'));
			text = text.replace('%TASKS%', this.stats.tasks + ' ' + D.Lang.nget(this.stats.tasks, 'event.finished.tasks2'));
			text = text.replace('%GROUPIE%', this.stats.crazywolf);
			text = text.replace('%EXPERT%', this.stats.brainteaser + ' ' + D.Lang.nget(this.stats.brainteaser, 'event.finished.expert'));
			text = text.replace('%EVENT%', this.event.title);
			mkE({
				tag: 'div',
				className: 'container single-event-finish-about',
				els: [
					{
						tag: 'div',
						className: 'single-event-block-new',
						els: [
							{
								tag: 'h2',
								className: 'title',
								text: D.Lang.get('event.finished.about.title')
							},
							{
								tag: 'p',
								className: 'text',
								text: text
							}
						]
					}
				]
			}).append(this.node);
		},

		_drawStats() {
			let container = mkE({
				tag: 'div',
				className: 'container single-event-stats',
				els: [
					{
						tag: 'div',
						className: 'single-event-block-new',
						els: [
							{
								tag: 'h2',
								className: 'title',
								text: D.Lang.get('event.finished.stats.title')
							}
						]
					}
				]
			}).append(this.node);
			this._statsNode = mkE({
				tag: 'div',
				className: 'stats'
			}).append(container);
			if (window.innerWidth < 1200 && this._currentStats !== 'mobile') {
				this._renderMobileStats();
			} else if (this._currentStats !== 'desktop') {
				this._renderDesktopStats();
			}

		},

		_renderDesktopStats() {
			this._currentStats = 'desktop';
			clearNode(this._statsNode);

			let bubbles = this._getStatsBubbles();
			let columns = 1;
			if (bubbles.length > 6) {
				columns = 2;
			}
			let col1 = mkE({
				tag: 'div',
				className: 'col col-1'
			});
			let col2 = mkE({
				tag: 'div',
				className: 'col col-2'
			});
			bubbles.forEach((section, index) => {
				let item = mkE({
					tag: 'div',
					className: 'stats-item',
					els: [
						{
							tag: 'div',
							className: 'stat-item-value',
							text: this.stats[section === 'hunter' ? 'treasure' : section] || 0
						},
						{
							tag: 'div',
							className: 'stats-item-text',
							text: D.Lang.get('event.finished.stats.items.' + section)
						}
					]
				});
				if (columns === 1 || index < 5) {
					item.append(col1);
				} else {
					item.append(col2);
				}
			});
			let columnsNode = mkE({
				tag: 'div',
				className: 'stat-columns',
				els: [
					col1
				]
			});
			if (columns === 2) {
				col2.append(columnsNode);
			}
			mkE({
				tag: 'div',
				className: 'stats-container',
				els: [
					columnsNode,
					{
						tag: 'div',
						className: 'stats-arrow'
					}
				]
			}).append(this._statsNode);
			if (columns === 2) {
				this._statsButton = mkE({
					tag: 'button',
					className: 'button button-turquoise',
					text: D.Lang.get('event.finished.stats.more'),
					onclick: () => {
						if (this._statsExpanded) {
							setNodeText(this._statsButton, D.Lang.get('event.finished.stats.more'));
							removeClassName(columnsNode, 'open');
							this._statsExpanded = false;
						} else {
							setNodeText(this._statsButton, D.Lang.get('event.finished.stats.hide'));
							addClassName(columnsNode, 'open');
							this._statsExpanded = true;
						}
					}
				}).append(this._statsNode);
			}
		},

		_renderMobileStats() {
			this._currentStats = 'mobile';
			clearNode(this._statsNode);

			let items = mkE({
				tag: 'div',
				className: 'stats-mobile-items'
			}).append(this._statsNode);

			let bubbles = this._getStatsBubbles();
			bubbles.forEach((section, index) => {
				mkE({
					tag: 'div',
					className: 'stats-mobile-item',
					els: [
						{
							tag: 'div',
							className: 'value',
							text: this.stats[section === 'hunter' ? 'treasure' : section] || 0
						},
						{
							tag: 'div',
							className: 'caption',
							text: D.Lang.get('event.finished.stats.items.' + section)
						}
					]
				}).append(items);
			});
		},

		_checkStatsRender() {
			if (window.innerWidth < 1200 && this._currentStats !== 'mobile') {
				this._renderMobileStats();
			} else if (window.innerWidth >= 1200 && this._currentStats !== 'desktop') {
				this._renderDesktopStats();
			}
		},

		_getStatsBubbles() {
			let bubbles = [];
			if (this.event.settings.hasPhotoMatching) {
				bubbles.push('imagematch');
			}
			if (this.event.settings.hasQuestions) {
				bubbles.push('question');
			}
			if (this.event.settings.hasDetective) {
				bubbles.push('clues');
			}
			if (this.event.settings.hasPacman) {
				bubbles.push('pacmanDiamonds');
			}
			if (this.event.settings.hasHotCold) {
				bubbles.push('hotcold');
			}
			if (this.event.settings.hasCrazyWolves) {
				bubbles.push('crazywolf');
			}
			if (this.event.settings.hasBrainTeaser) {
				bubbles.push('brainteaser');
			}
			if (this.event.settings.hasTreasure) {
				bubbles.push('hunter');
			}
			if (this.event.settings.hasGoldDigger) {
				bubbles.push('golddigger');
			}
			if (this.event.settings.hasCoder) {
				bubbles.push('coder');
			}
			return bubbles;
		},

		_drawTop() {
			let container = mkE({
				tag: 'div',
				className: 'container single-event-top',
				els: [
					{
						tag: 'a',
						className: 'anchor',
						id: 'results'
					},
					{
						tag: 'div',
						className: 'single-event-block-new',
						els: [
							{
								tag: 'h2',
								className: 'title',
								text: D.Lang.get('event.finished.top.title')
							},
							this._topSearchContainer = mkE({
								tag: 'div',
								className: 'single-event-top-search'
							})
						]
					}
				]
			}).append(this.node);
			new T.Top(null, {
				eventId: this.event.id,
				seoTitle: this.event.seoTitle
			}, {
				searchContainer: this._topSearchContainer
			}).append(container);
		},

		_drawVideo() {
			let video = null;
			let livestream = null;
			let ratio = '16by9';
			switch (this.event.id) {
				case 1:
					video = 'https://www.youtube-nocookie.com/embed/AkC2itnMMBQ?rel=0';
					ratio = '18by9';
					break;
				case 7:
					video = 'https://www.youtube-nocookie.com/embed/0MuZYM9jlYY?rel=0';
					livestream = true;
					break;
				default:
					return;
			}
			mkE({
				tag: 'div',
				className: 'container single-event-video',
				id: 'video',
				els: [
					{
						tag: 'div',
						className: 'single-event-block',
						els: [
							{
								tag: 'div',
								className: 'caption',
								text: D.Lang.get('event.finished.video.caption' + (livestream ? 'Livestream' : ''))
							},
							{
								tag: 'h2',
								className: 'title h1',
								text: D.Lang.get('event.finished.video.title' + (livestream ? 'Livestream' : ''))
							}
						]
					},
					{
						tag: 'div',
						className: 'video video-' + ratio,
						els: [
							D.cookieConsent('marketing', mkE({
								tag: 'iframe',
								style: {
									overflow: 'hidden',
									height: '100%',
									width: '100%'
								},
								src: video,
								attr: {
									frameborder: 0,
									allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
									allowfullscreen: ''
								}
							}))
						]
					}
				]
			}).append(this.node);
		},

		onShow() {
			PARENT.onShow();
			window.addEventListener('resize', this._onResize);
		},

		onLeave() {
			PARENT.onLeave();
			window.removeEventListener('resize', this._onResize);
		},

		_onResize() {
			this._checkStatsRender();
		}

	},
	RoadgamesEvent.Base
);
